import { StyleSheet } from 'aphrodite';
import * as React from 'react';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { OutcomeMultiSelectDropdown } from '../../../components/leadView/components/OutcomeMultiSelectDropdown';

interface IOutcomeOption {
	name?: string;
	checked?: boolean;
	children?: IOutcomeOption[];
}

const checkedOutcomeNames = (tree: IOutcomeOption[]): string[] | null => {
	const outcomes = tree.flatMap(option => option.children ?? []);
	const checked = outcomes.filter(outcome => outcome.checked);
	if (checked.length === outcomes.length) {
		return null;
	}
	return checked.map(outcome => outcome.name).filter((name): name is string => !!name);
};

const sameOutcomes = (a: string[] | null, b: string[] | null) => (a ?? []).join('\n') === (b ?? []).join('\n');

interface IProps {
	outcomes: string[] | null;
	onChange: (outcomes: string[] | null) => void;
}

// The dropdown is uncontrolled and refetches on new defaults, so it remounts only when outcomes change from outside.
export const OutcomeFilter: React.FC<IProps> = ({ outcomes, onChange }) => {
	const [synced, setSynced] = React.useState(outcomes);
	const [mounted, setMounted] = React.useState({ initial: outcomes, key: 0 });

	if (!sameOutcomes(outcomes, synced)) {
		setSynced(outcomes);
		setMounted(current => ({ initial: outcomes, key: current.key + 1 }));
	}

	return (
		<OutcomeMultiSelectDropdown
			key={mounted.key}
			defaultChecked={!mounted.initial?.length}
			defaultValues={mounted.initial ?? undefined}
			triggerStyles={[styleSheet.trigger]}
			onChange={tree => {
				const next = checkedOutcomeNames(tree);
				setSynced(next);
				onChange(next);
			}}
		/>
	);
};

const styleSheet = StyleSheet.create({
	trigger: {
		backgroundColor: THEME.colors.background.light,
	},
});
